// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"51a71f80","551":"4034a69b","714":"383b0a69"}[chunkId] + ".chunk.css";
};